import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';

import Placeholder from 'components/consumer/Placeholder';
import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPInfoTable from '../PDPInfoTable';

import Prefetcher from '../../../essentials/Prefetcher';

const PDPDimensionsContentUI = ({
  dimensionsDesktopImage,
  dimensionsMobileImage,
  dimensions = [],
  boxDimensions = [],
  loading = false,
  onImageClick,
  isSidebarContent = false,
}) => {
  const desktopImageFullWidthProps = useFixedWidthContainerSizeProps();

  const desktopImageProps = isSidebarContent
    ? { sizes: '30vw' }
    : desktopImageFullWidthProps;

  return (
    <div className="PDPDimensionsContentUI">
      {loading && (
        <Placeholder
          loading
          type="rect"
          style={{ marginRight: 0, marginTop: '10px', height: '207px' }}
        />
      )}

      {!loading && (
        <>
          {dimensionsMobileImage && (
            <MobileAndTabletOnly>
              <JBImage
                src={dimensionsMobileImage}
                sizes="100vw"
                height="900"
                width="900"
                className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden"
              />
            </MobileAndTabletOnly>
          )}

          {dimensionsDesktopImage && (
            <DesktopOnly>
              <Prefetcher
                onHoverAssets={[
                  {
                    url: dimensionsDesktopImage,
                    imgixProps: {
                      ...desktopImageFullWidthProps,
                    },
                  },
                ]}
              >
                <JBImage
                  src={dimensionsDesktopImage}
                  onClick={onImageClick}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...desktopImageProps}
                  className={classNames(
                    'w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden',
                    {
                      'hover:cursor-target': onImageClick,
                    }
                  )}
                />
              </Prefetcher>
            </DesktopOnly>
          )}
        </>
      )}

      <div className="max-w-[480px] mx-auto my-0">
        <PDPInfoTable items={dimensions} loading={loading} />
      </div>
      {boxDimensions?.length > 0 && (
        <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]">
          <div className="max-w-[480px] mx-auto my-0">
            <h2 className="text-xl font-bold text-gray">
              {loading ? (
                <Placeholder
                  type="rect"
                  loading
                  style={{ height: '28px', width: '220px' }}
                />
              ) : (
                'Shipping Dimensions'
              )}
            </h2>
          </div>
          <div className="max-w-[480px] mx-auto my-0">
            <PDPInfoTable items={boxDimensions} loading={loading} />
          </div>
        </div>
      )}
    </div>
  );
};

PDPDimensionsContentUI.propTypes = {
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  boxDimensions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  loading: PropTypes.bool,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
};

export default PDPDimensionsContentUI;
